import { z } from 'zod';
import { defineCollection, type RecordOf } from '../collection.ts';
import { isoDate, requiredText, shortText } from '../fields.ts';

/** Short household notices ("Plumber coming Thursday 9–11"). Comments add a small thread. */
export const notices = defineCollection({
  name: 'notices',
  module: 'board',
  label: { one: 'notice', other: 'notices' },
  schema: z.object({
    body: requiredText(1_000),
    emoji: shortText(16).default(''),
    pinned: z.boolean().default(false),
    /** Hidden from the home screen after this date. */
    expiresOn: isoDate.nullable().default(null),
  }),
  defaultAudience: 'family',
  childAccess: 'contribute',
  editPolicy: 'author',
  immutableFields: [],
  manualMergeFields: [],
});

export type Notice = RecordOf<typeof notices>;
